<div class="mail-container" style="display: flex; gap: 2rem; position: absolute;"
     [ngStyle]="{
       'left': admin.sidebarShow ? '15%' : '4%',
       'width': admin.sidebarShow ? '85%' : '96%'
     }">
  <!-- Columna Izquierda: Enviados -->
  <div class="column" style="flex: 1;">
    <h2>Enviados</h2>
    <div *ngIf="!sent.length">— Ninguno aún —</div>
    <div *ngFor="let msg of sent" class="thread">
      <div>
        <strong>Para:</strong>
        <a [href]="'mailto:' + senderEmail(msg.to, msg.to)"> <!-- senderEmail not needed list==raw here -->
          {{ msg.to }}
        </a>
      </div>
      <div>
        <strong>{{ msg.subject }}</strong>
        <small>({{ msg.date }})</small>
      </div>
      <div class="snippet" [innerHTML]="msg.body_plain | slice:0:200"></div>
    </div>
  </div>

  <!-- Columna Centro: Recibidos -->
  <div class="column" style="flex: 1; display: flex; flex-direction: column; gap: 1rem;">
    <!-- Exactos -->
    <section>
      <h3>Recibidos (Exactos)</h3>
      <div *ngIf="!receivedExact.length">— Ninguno —</div>
      <div *ngFor="let msg of receivedExact" class="thread">
        <div>
          <strong>De:</strong>
          <a [href]="'mailto:' + senderEmail(msg.external, msg.from)">
            {{ senderEmail(msg.external, msg.from) }}
          </a>
        </div>
        <div>
          <strong>{{ msg.subject }}</strong>
          <small>({{ msg.date }})</small>
        </div>
        <div class="snippet" [innerHTML]="msg.body_plain | slice:0:200"></div>
      </div>
    </section>

    <!-- Por Dominio -->
    <section>
      <h3>Recibidos (Dominio)</h3>
      <div *ngIf="!receivedDomain.length">— Ninguno —</div>
      <div *ngFor="let msg of receivedDomain" class="thread">
        <div>
          <strong>De:</strong>
          <a [href]="'mailto:' + senderEmail(msg.external, msg.from)">
            {{ senderEmail(msg.external, msg.from) }}
          </a>
        </div>
        <div>
          <strong>{{ msg.subject }}</strong>
          <small>({{ msg.date }})</small>
        </div>
        <div class="snippet" [innerHTML]="msg.body_plain | slice:0:200"></div>
      </div>
    </section>

    <!-- Desconocidos -->
    <section>
      <h3>Recibidos (Desconocidos)</h3>
      <div *ngIf="!receivedUnknown.length">— Ninguno —</div>
      <div *ngFor="let msg of receivedUnknown" class="thread">
        <div>
          <strong>De:</strong>
          <a [href]="'mailto:' + senderEmail(msg.external, msg.from)">
            {{ senderEmail(msg.external, msg.from) }}
          </a>
        </div>
        <div>
          <strong>{{ msg.subject }}</strong>
          <small>({{ msg.date }})</small>
        </div>
        <div class="snippet" [innerHTML]="msg.body_plain | slice:0:200"></div>
      </div>
    </section>
  </div>

  <!-- Columna Derecha: Enviados a Previos -->
  <div class="column" style="flex: 1;">
    <h2>Enviados a Previos</h2>
    <div *ngIf="!sentToPrevious.length">— Ninguno —</div>
    <div *ngFor="let msg of sentToPrevious" class="thread">
      <div>
        <strong>Para:</strong>
        <a [href]="'mailto:' + senderEmail(msg.to, msg.to)">
          {{ msg.to }}
        </a>
      </div>
      <div>
        <strong>{{ msg.subject }}</strong>
        <small>({{ msg.date }})</small>
      </div>
      <div class="snippet" [innerHTML]="msg.body_plain | slice:0:200"></div>
    </div>
  </div>
</div>
